export default "__VITE_ASSET__69f80aeb__"